import React, { createContext, useState, useContext, useEffect } from "react";
import Axios from "../axios";
import { staticNavData } from "../navigation/sidenav/sidenavData";
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("username");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [role, setRole] = useState(() => localStorage.getItem("role"));
  const [roles, setRoles] = useState([]);
  const [navData, setNavData] = useState([]);
  const [openSideNav, setOpenSideNav] = useState(true);

  // Store token in localStorage whenever it changes
  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  // Fetch roles when token is set (after login)
  useEffect(() => {
    if (token) {
      const fetchRoles = async () => {
        let data = {
          page: 1,
          searchChar: "",
        };
        try {
          const resp = await Axios.post(
            `${process.env.REACT_APP_BACKEND}get-roles`,
            data
          );
          setRoles(resp?.data?.data || []); // Set roles with permissions data
        } catch (err) {
          console.error("Error fetching roles", err);
          if (err.response && err.response.status === 401) {
            window.location.reload();
          }
        }
      };

      fetchRoles();
    }
  }, [token]);

  // Update navigation data based on user role and permissions
  useEffect(() => {
    if (roles.length > 0 && role) {
      const userRole = roles.find((r) => r.role === role);

      if (userRole) {
        const filteredNavData = staticNavData
          .map((navItem) => {
            const permission = userRole.permissions.find(
              (perm) => perm.page === navItem.text
            );

            // Add 'read' and 'write' to navItem if permission exists
            return {
              ...navItem,
              read: permission?.read || false,
              write: permission?.write || false,
            };
          })
          .filter((navItem) => navItem.read || navItem.write); // Filter based on read or write permissions

        setNavData(filteredNavData);
      }
    }
  }, [roles, role]);

  const login = (userObj, token) => {
    setToken(token);
    setUser(userObj);
    setRole(userObj.role);
    localStorage.setItem("token", token);
    localStorage.setItem("username", JSON.stringify(userObj));
    localStorage.setItem("role", userObj?.role);
    localStorage.setItem("email", userObj?.email);
    localStorage.setItem("name", userObj?.name);
    window.location.reload();
  };

  const signup = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setRole(null);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("name");
    localStorage.clear();
  };

  const SideNav = (val) => {
    setOpenSideNav(val);
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        role,
        roles,
        navData,
        openSideNav,
        login,
        signup,
        logout,
        SideNav,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
